import { normalizeValue } from './normalizeValue';
import { upperCaseValue } from './upperCaseValue';

export function endsWith(value: string | undefined, suffix: string | undefined): boolean {
	if (!suffix) {
		return false;
	}

	const normalized = normalizeValue(value);
	if (!normalized) {
		return false;
	}

	return normalized.endsWith(suffix);
}

export function endsWithIgnoreCase(value: string | undefined, suffix: string | undefined): boolean {
	const upperValue = upperCaseValue(value);
	const upperSuffix = upperCaseValue(suffix);
	return endsWith(upperValue, upperSuffix);
}
